import { validations } from './validations';

/**
 * Questions about beer types, brands, and categories
 */
export const beerTypesQuestions = [
  {
    id: 'common-beer-brands',
    question: 'Quais as cervejas comuns que você mais consome?',
    subtitle: '(marque até 3)',
    type: 'checkbox',
    options: [
      { value: 'amstel', label: 'Amstel' },
      { value: 'antárctica', label: 'Antárctica' },
      { value: 'becks', label: 'Becks' },
      { value: 'berrió', label: 'Berrió' },
      { value: 'bohemia', label: 'Bohemia' },
      { value: 'brahma', label: 'Brahma' },
      { value: 'brahma duplo malte', label: 'Brahma Duplo Malte' },
      { value: 'budweiser', label: 'Budweiser' },
      { value: 'cacildis', label: 'Cacildis' },
      { value: 'corona', label: 'Corona' },
      { value: 'devassa', label: 'Devassa' },
      { value: 'eisenbahn', label: 'Eisenbahn' },
      { value: 'esmera', label: 'Esmera' },
      { value: 'estrella galicia', label: 'Estrella Galicia' },
      { value: 'heineken', label: 'Heineken' },
      { value: 'império', label: 'Império' },
      { value: 'itaipava', label: 'Itaipava' },
      { value: 'kaiser', label: 'Kaiser' },
      { value: 'magnífica', label: 'Magnífica' },
      { value: 'original', label: 'Original' },
      { value: 'petra', label: 'Petra' },
      { value: 'polar', label: 'Polar' },
      { value: 'skol', label: 'Skol' },
      { value: 'sol', label: 'Sol' },
      { value: 'spaten', label: 'Spaten' },
      { value: 'stella artois', label: 'Stella Artois' },
      { value: 'stella artois pure gold', label: 'Stella Artois Pure Gold' },
      { value: 'nenhuma (bebo somente artesanais)', label: 'NENHUMA (Bebo somente artesanais)' },
    ],
    allowOther: true,
    exclusiveOptions: ['nenhuma (bebo somente artesanais)'],
    minSelections: 1,
    maxSelections: 3,
    validation: validations.checkboxMinMax(1, 3)
  },
  {
    id: 'common-beer',
    question: 'Que tipo de cerveja você costuma beber?',
    subtitle: 'Observe os seguintes significados: <br/><strong>- Cervejas comuns:</strong> Marcas conhecidas, de custo baixo a médio, distribuídas nacionalmente (exemplo: Brahma, Original, Antartica, Skol, Heineken, Spaten, Império).<br/><strong>- Cervejas Especiais:</strong> Marcas de valor médio a alto, com receitas diferentes mas ainda de grandes conglomerados (exemplo: Baden Baden, Hoeegarden, Colorado, Paulaner, Lagunitas).<br/><strong>- Cervejas Artesanais:</strong> Marcas de maior valor, com grande variedade de receitas, e de cervejarias menores, muitas vezes regionais (exemplo: Hocus Pocus, Bodebrown, Schornstein, Turatti, Louvada, etc).',
    type: 'radio',
    options: [
      { value: 'comuns, especiais e artesanais', label: 'Comuns, Especiais e Artesanais' },
      { value: 'comuns e especiais', label: 'Comuns e Especiais' },
      { value: 'somente comuns', label: 'Somente Comuns' },
    ],
    nextQuestion: (answer) => {
      if (answer === 'comuns, especiais e artesanais') {
        return 'beer-relationship';
      }
      return 'other-drinks';
    },
    validation: validations.required
  },
];
